export default __webpack_public_path__ + "static/media/CNo.63-3.11226221.jpg";